import React from "react";
import Modal from "../../Common/Modal";
import MtiButton from "../../Buttons/MtiButton";
import "./FindSafePositionModalProgress.css";


type Props = {
  show: boolean;
  onHide: () => void;
  disableAnimation: boolean;
};

export default function FindSafePositionFailedModal({
  show,
  onHide,
  disableAnimation,
}: Props) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      className={
        disableAnimation
          ? "auto-calibration-progress-modal"
          : "auto-calibration-progress-modal done"
      }
    >
      <Modal.Header
        title={"Find Safe Position"}
        hideButtonEnabled={false}
        className="auto-calibration-progress-header"
      />
      <Modal.Body className="auto-calibration-progress-body">
        <svg
          width="71"
          height="71"
          viewBox="0 0 71 71"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M70.0834 35.4994C70.0834 54.5992 54.5999 70.0827 35.5001 70.0827C16.4002 70.0827 0.916748 54.5992 0.916748 35.4994C0.916748 16.3995 16.4002 0.916016 35.5001 0.916016C54.5999 0.916016 70.0834 16.3995 70.0834 35.4994ZM21.6667 56.2494L35.5001 42.416L49.3334 56.2494L56.2501 49.3327L42.4167 35.4994L56.2501 21.666L49.3334 14.7493L35.5001 28.5827L21.6667 14.7493L14.7501 21.666L28.5834 35.4994L14.7501 49.3327L21.6667 56.2494Z"
            fill="#DB0000"
          />
        </svg>

        <div className="progress-title">
          <p>Failed to find Safe Position</p>
        </div>
        <div className="progress-subtittle">
            Contact support@formulatrix.com for assistance.
        </div>
        <MtiButton
          variant="primary"
          size="large"
          onClick={onHide}
          style={{
            width: 125,
            alignSelf: "flex-end",
          }}
        >
          <span>OK</span>
        </MtiButton>
      </Modal.Body>
    </Modal>
  );
}
